import { CookiePolicyContent } from '@ophelos/ui/components/legal/cookie-policy-content';
import type { Language } from '@ophelos/ui/components/legal/cookie-consent-copy';
import { cn } from '@ophelos/ui/lib/utils';
import { OphelosIcon } from '@/components/branding/ophelos-icon';
import { Layout } from '@/components/layout/Layout';
import { SettingsMenu } from '@/components/ui/SettingsMenu';
import { useTheme } from '@/components/layout/ThemeProvider';
import { useConfiguration } from '@/contexts/ConfigurationContext';
import { useCookieConsentSettings } from '@/contexts/CookieConsentContext';
import { useLanguage } from '@/contexts/LanguageContext';

function toCopyLanguage(code: string): Language {
  if (code.startsWith('pt')) return 'pt';
  if (code.startsWith('fr')) return 'fr';
  return 'en';
}

export default function CookiePolicy() {
  const { currentLanguage } = useLanguage();
  const { config } = useConfiguration();
  const { theme } = useTheme();
  const cookieConsent = useCookieConsentSettings();

  // Operator logo (theme-selected) with the Ophelos mark as fallback — mirrors the login page.
  const logo = config.ui.branding.logo;
  const logoUrl = theme === 'dark' ? logo?.dark : logo?.light;

  return (
    <Layout>
      <SettingsMenu className="absolute top-4 max-md:left-4 md:right-4 z-20" />
      {/* Reserve space for the fixed consent banner so the last text stays visible. */}
      <div className={cn('mx-auto w-full max-w-3xl px-4 py-10 md:py-16', cookieConsent?.bannerOpen && 'pb-80 md:pb-52')}>
        {logoUrl ? (
          <img src={logoUrl} alt={logo?.alt || 'Logo'} className="mb-10 h-8 w-auto max-w-32 object-contain" />
        ) : (
          <OphelosIcon className="mb-10 size-9 text-foreground" />
        )}
        <CookiePolicyContent language={toCopyLanguage(currentLanguage)} />
      </div>
    </Layout>
  );
}
